<div class="rd-widget rd-widget-no-height-restriction widgetNoTopBorder">
  <table class="widget-small cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-small">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tr>
      <th scope="col" colspan="13" class="widgetNoTopBorderShowCell darkGreyTableHeader swot-header"><widget-label [widget]="this" [fieldName]="'strengths'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></th>
      <td colspan="1" class="space widgetNoTopBorderShowCell">&nbsp;</td>
      <th scope="col" colspan="13" class="widgetNoTopBorderShowCell darkGreyTableHeader swot-header"><widget-label [widget]="this" [fieldName]="'weaknesses'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></th>
    </tr>
    <tr>
      <!--strengths-->
      <td colspan="13" *ngIf="editMode">
        <textarea class="gridster-item-content"
                  hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId" [page]="page" [elType]="'text'" [editMode]="editMode" (setNewValue)=" widgetData.strengths = $event; dataChanged()" id="strengths"
                  [(ngModel)]="widgetData.strengths" cols="72" rows="8" (blur)="clampText($event);" [disabled]="!editMode" (ngModelChange)="setDirtyFlag(true)"></textarea>
      </td>
      <td colspan="13" *ngIf="!editMode">
        <textarea class="gridster-item-content"
                  hashtagsetvalue [widget]="this" [page]="page" id="strengths"
                  [ngModel]="widgetData.strengths" cols="72" rows="8" [disabled]="!editMode"></textarea>
      </td>
      <td colspan="1" class="space">&nbsp;</td>
      <!--weaknesses-->
      <td colspan="13" *ngIf="editMode">
        <textarea class="gridster-item-content" [editMode]="editMode" (setNewValue)="widgetData.weaknesses = $event; dataChanged()" [widgetId]="this.widgetConfig.widgetId"
                  hashtag [widget]="this" [selectedTag]="hashTag" [elType]="'text'" id="weaknesses" [page]="page"
                  [(ngModel)]="widgetData.weaknesses" cols="72" rows="8" (blur)="clampText($event);" [disabled]="!editMode" (ngModelChange)="setDirtyFlag(true)"></textarea>
      </td>
      <td colspan="13" *ngIf="!editMode">
        <textarea class="gridster-item-content"
                  hashtagsetvalue [widget]="this" [page]="page" id="weaknesses"
                  [ngModel]="widgetData.weaknesses" cols="72" rows="8" [disabled]="!editMode"></textarea>
      </td>
    </tr>
    <tr>
      <th scope="col" colspan="13" class="widgetNoTopBorderShowCell darkGreyTableHeader swot-header"><widget-label [widget]="this" [fieldName]="'opportunities'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></th>
      <td colspan="1" class="space widgetNoTopBorderShowCell">&nbsp;</td>
      <th scope="col" colspan="13" class="widgetNoTopBorderShowCell darkGreyTableHeader swot-header"><widget-label [widget]="this" [fieldName]="'threats'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label></th>
    </tr>
    <tr>
      <!--opportunities-->
      <td colspan="13" *ngIf="editMode">
        <textarea class="gridster-item-content"
                  hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId" [page]="page" [elType]="'text'" [editMode]="editMode" (setNewValue)="widgetData.opportunities = $event; dataChanged()" id="opportunities"
                  [(ngModel)]="widgetData.opportunities" cols="72" rows="8" (blur)="clampText($event);" [disabled]="!editMode" (ngModelChange)="setDirtyFlag(true)"></textarea>
      </td>
      <td colspan="13" *ngIf="!editMode">
        <textarea class="gridster-item-content"
                  hashtagsetvalue [widget]="this" [page]="page" id="opportunities"
                  [ngModel]="widgetData.opportunities" cols="72" rows="8" [disabled]="!editMode"></textarea>
      </td>
      <td colspan="1" class="space">&nbsp;</td>
      <!--threats-->
      <td colspan="13" *ngIf="editMode">
        <textarea class="gridster-item-content"
                  hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId" [page]="page" [elType]="'text'" [editMode]="editMode" (setNewValue)="widgetData.threats = $event; dataChanged()" id="threats"
                  [(ngModel)]="widgetData.threats" cols="72" rows="8" (blur)="clampText($event);" [disabled]="!editMode" (ngModelChange)="setDirtyFlag(true)"></textarea>
      </td>
      <td colspan="13" *ngIf="!editMode">
        <textarea class="gridster-item-content"
                  hashtagsetvalue [widget]="this" [page]="page" id="threats"
                  [ngModel]="widgetData.threats" cols="72" rows="8" [disabled]="!editMode"></textarea>
      </td>
    </tr>
  </table>
</div>
